import Vue from "vue";
import VueRouter from "vue-router";
import home from "@/components/home";
import login from "@/components/login";
import members from "@/components/Members";
import equipment from "@/components/Equipment";
import classes from "@/components/Classes";
import payments from "@/components/Payments";
import attendance from "@/components/Attendance";
import reports from "@/components/Reports";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: login,
  },
  {
    path: "/Dashboard",
    name: "home",
    component: home,
  },
  {
    path: "/members",
    name: "members",
    component: members,
  },
  {
    path: "/equipment",
    name: "equipment",
    component: equipment,
  },
  {
    path: "/classes",
    name: "classes",
    component: classes,
  },
  {
    path: "/payments",
    name: "payments",
    component: payments,
  },
  {
    path: "/attendance",
    name: "attendance",
    component: attendance,
  },
  {
    path: "/reports",
    name: "reports",
    component: reports,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
